<template>
  <div class="header_box" @touchmove.prevent>
    <!-- pc 通用头部 -->
    <header class="header" v-if="!isM">
      <router-link to="/">
        <h1 class="h1_class">车镇车源</h1>
      </router-link>
      <div class="links">
        <div>
          <a class="link_tit" href="javascript:void(0)" id="cp_switch"
            >产品服务</a
          >
          <!-- 下拉菜单 -->
          <transition name="fade">
            <ul class="menu_box cp_menu" v-show="showMenu" id="menu_box">
              <li v-for="item in cplist" :key="item.id">
                <router-link :to="item.link">{{ item.name }}</router-link>
              </li>
            </ul>
          </transition>
        </div>

        <div>
          <router-link class="link_tit" to="/Aboutus">关于我们</router-link>
        </div>

        <div>
          <router-link class="link_tit" to="/Cartownnews">车镇动态</router-link>
        </div>

        <div>
          <router-link class="link_tit" to="/Contactus">联系我们</router-link>
        </div>
      </div>
    </header>

    <!-- M 通用头部 -->
    <header v-if="isM">
      <div class="headerm_up">
        <i class="m_menu" @click="changeMenu" v-if="!showMenum"></i>
        <i class="m_menu_close" @click="changeMenu" v-if="showMenum"></i>
        <h1 class="h1_class" @click="goIndex">车镇车源</h1>
      </div>
      <transition name="menuleft">
        <div class="m_menu_box" v-show="showMenum" @touchmove.prevent>
          <ul class="mm1_box">
            <li>
              <div class="mm1_tit" @click="changeUl">
                <h6>产品服务</h6>
                <i :class="show1 ? 'trans' : ''"></i>
              </div>
              <transition name="menu">
                <ul class="incl_ul" v-show="show1">
                  <li v-for="item in cplist" :key="item.id" @click="changeMenu">
                    <router-link :to="item.link">{{ item.name }}</router-link>
                  </li>
                </ul>
              </transition>
            </li>

            <li class="mm1_tit" @click="changeMenu">
              <router-link class="link_tit" to="/Aboutusm"
                >关于我们</router-link
              >
            </li>

            <li class="mm1_tit" @click="changeMenu">
              <router-link class="link_tit" to="/Cartownnews"
                >车镇动态</router-link
              >
            </li>

            <li class="mm1_tit" @click="changeMenu">
              <router-link class="link_tit" to="/Contactus"
                >联系我们</router-link
              >
            </li>
          </ul>
        </div>
      </transition>
    </header>
  </div>
</template>

<script>
export default {
  name: "czheader",
  props: ["pageName", "backIndex"],
  data() {
    return {
      showMenu: false,
      showMenum: false,
      show1: false,
      cplist: [
        { link: "/Czcy", name: "车镇车源" },
        { link: "/Czwl", name: "车镇物流" },
        { link: "/Cycj", name: "车源采集" },
        { link: "/Zhcc", name: "智慧车城" },
      ],
      isM: false,
    };
  },
  created() {
    setTimeout(() => {
      this.isM = JSON.parse(sessionStorage.getItem("isM"));
    }, 200);

    let body = document.querySelector("body");
    body.addEventListener(
      "click",
      (e) => {
        if (e.target.id === "cp_switch" || e.target.id === "menu_box") {
          this.showMenu = !this.showMenu;
        } else {
          this.showMenu = false;
        }
      },
      false
    );
  },
  watch: {
    showMenum: function (newVal) {
      if (newVal) {
        this.stop();
      } else {
        this.move();
      }
    },
  },
  methods: {
    changeMenu() {
      this.showMenum = !this.showMenum;
    },
    changeUl() {
      this.show1 = !this.show1;
    },
    goIndex() {
      this.showMenum = false;
      this.$router.push({
        path: "/Indexm",
      });
    },
    goAboutus(idx) {
      this.changeMenu();
      this.$router.push({
        path: "/Aboutusm",
        query: {
          idx: idx,
        },
      });
    },
    stop() {
      document.body.style.overflow = "hidden"; //禁止页面划动
    },
    move() {
      document.body.style.overflow = ""; //出现滚动条
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/components/commonhead.vue